$(document).on("fieldChange fieldsAdded" , ()=>{
    let legislativeMeetingCards = $('.legislative-meetings-container').find('fieldset');
    if (legislativeMeetingCards.length) {
        legislativeMeetingCards.each((index, element) => {
            let ind = index + 1;
            let $interestTitle = $(element).find('legend');
            let titleReplacement = $interestTitle.text().replace(/(\d+)/, `${ind}`);
            $interestTitle.text(titleReplacement);
        });
    }

    let conditionalCards = $(".conditional-fields-container").find('fieldset');
        if (conditionalCards.length) {
            conditionalCards.each((index, element) => {
                let ind = index + 1;
                let $interestTitle = $(element).find('legend');
                let titleReplacement = $interestTitle.text().replace(/(\d+)/, `${ind}`);
                $interestTitle.text(titleReplacement);
            });
    }
    let speakingEngagementCards = $(".speaking-engagements-container").find('fieldset');
    if (speakingEngagementCards.length) {
        speakingEngagementCards.each((index, element) => {
            let ind = index + 1;
            let $interestTitle = $(element).find('legend');
            let titleReplacement = $interestTitle.text().replace(/(\d+)/, `${ind}`);
            $interestTitle.text(titleReplacement);
        });
    }

    let mealsAndBeveragesCards = $(".meals-and-beverages-container").find('fieldset');
    if (mealsAndBeveragesCards.length) {
        mealsAndBeveragesCards.each((index, element) => {
            let ind = index + 1;
            let $interestTitle = $(element).find('legend');
            let titleReplacement = $interestTitle.text().replace(/(\d+)/, `${ind}`);
            $interestTitle.text(titleReplacement);
        });
    }

    let additionalEntitiesCards = $(".additional-entities-container").find("fieldset");
    if (additionalEntitiesCards.length) {
        additionalEntitiesCards.each((index, element) => {
            let ind = index + 1;
            let $interestTitle = $(element).find('legend');
            let titleReplacement = $interestTitle.text().replace(/(\d+)/, `${ind}`);
            $interestTitle.text(titleReplacement);
        });
    }






});
